import { render, staticRenderFns } from "./check-edit.vue?vue&type=template&id=355edcf8"
import script from "./check-edit.vue?vue&type=script&lang=ts"
export * from "./check-edit.vue?vue&type=script&lang=ts"
import style0 from "./check-edit.vue?vue&type=style&index=0&id=355edcf8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports